// extracted by mini-css-extract-plugin
export default {"main":"IdvBlogSec_main__4d8R7","footer":"IdvBlogSec_footer__8Pkaf","socials":"IdvBlogSec_socials__RKVyf"};